import React from 'react'
import { Stack, Typography, Grid, Paper } from '@mui/material'
import { LineChart, BarChart } from '@mui/x-charts';
import GraphSelector from '../components/Report/GraphSelector';

const revenueData = [
	{ date: new Date(2024, 2, 1), value: 19000 }, // Note: Months are 0-indexed
	{ date: new Date(2024, 2, 8), value: 18500 },
	{ date: new Date(2024, 2, 15), value: 25000 },
	{ date: new Date(2024, 2, 22), value: 21000 },
	{ date: new Date(2024, 2, 29), value: 23000 },
	{ date: new Date(2024, 3, 5), value: 19000 }
];

const profitData = [
	{ date: new Date(2024, 2, 1), value: 2000 }, // Note: Months are 0-indexed
	{ date: new Date(2024, 2, 8), value: 1100 },
	{ date: new Date(2024, 2, 15), value: 8000 },
	{ date: new Date(2024, 2, 22), value: 5000 },
	{ date: new Date(2024, 2, 29), value: 9000 },
	{ date: new Date(2024, 3, 5), value: -1000 }
];

export default function ReportPage() {
	return (
		<Stack>
			<Typography variant="h5">Top Performing Products</Typography>
			<Stack gap={2} sx={{ margin: '10px' }}>
				<Paper sx={{ height: 300, width: '100%' }}>
					<BarChart
						yAxis={[
							{
								// Hide the Y-axis line but keep the labels:
								render: () => null,
							},
						]}
						xAxis={[
							{
								scaleType: 'band',
								data: ['Apsara Eraser', 'Maggi ...', 'Boroline'],
							}]}
						series={[{ data: [2, 7, 4] }]}
						height={300}
					/>
				</Paper>
				{/* <GraphSelector /> */}
			</Stack>

			<Typography variant="h5">Revenue Report</Typography>
			<Stack gap={2} sx={{ margin: '10px' }}>
				<Paper sx={{ height: 300, width: '100%' }}>
					<LineChart
						xAxis={[
							{
								data: revenueData.map((item) => item.date),
								scaleType: 'time', // or 'band' (see explanations below)
								// Optional Time Scale Formatting (if using scaleType: 'time')
								tickFormat: (value) => new Date(value).toLocaleDateString(),
							},
						]}
						series={[
							{
								data: revenueData.map((item) => item.value),
								curve: 'linear',
							},
						]}
					/>
				</Paper>
				{/* <GraphSelector /> */}
			</Stack>

			<Typography variant="h5">Profit Report</Typography>
			<Stack gap={2} sx={{ margin: '10px' }}>
				<Paper sx={{ height: 300, width: '100%' }}>
					<LineChart
						xAxis={[
							{
								data: profitData.map((item) => item.date),
								scaleType: 'time', // or 'band' (see explanations below)
								// Optional Time Scale Formatting (if using scaleType: 'time')
								tickFormat: (value) => new Date(value).toLocaleDateString(),
							},
						]}
						series={[
							{
								data: profitData.map((item) => item.value),
								curve: 'linear',
							}
						]}
					/>
				</Paper>
				{/* <GraphSelector /> */}
			</Stack>

		</Stack>
	);
}